import { React } from "react";
import {
  DialogContent,
  CardMedia,
  Typography,
  Paper,
  Box,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    margin: "0 auto",
  },
  paper: {
    borderRadius: 0,
    backgroundColor: theme.gray,
    width: 528,
    height: 228,
    alignContent: "center",
  },
  imagePreview: {
    width: 200,
    height: 230,
  },
  autocomplete: {
    borderRadius: 30,
  },
  textfield: {
    margin: "20px auto",
    [`& fieldset`]: {
      borderRadius: 50,
    },
  },
}));

function PreviewImage({ image }) {
  const classes = useStyles();

  return (
    <DialogContent className={classes.dialogContainer}>
      <Typography gutterBottom></Typography>
      <Paper className={classes.paper}>
        <Box
          style={{
            margin: "0 auto",
            display: "table",
            justifyContent: "center",
            // backgroundColor: "red",
          }}
        >
          <CardMedia
            className={classes.imagePreview}
            draggable={false}
            image={image}
          />
        </Box>
      </Paper>
    </DialogContent>
  );
}

export default PreviewImage;
